<template>
  <message-template :direction="'outgoing'" :time="time" :channel="channel">
    <div class="fb-carousel-layout">
      <div class="fb-carousel-wrapper">
        <div
          class="fb-generic-template"
          v-for="(block, blockIndex) in data.payload"
          :key="`${uid}-fb-${blockIndex}`"
        >
          <div class="fb-thumb-block" v-if="block.image_url">
            <img :src="block.image_url" alt="image" />
          </div>
          <div class="fb-data-block">
            <div class="title">{{block.title}}</div>
            <div class="subtitle">{{block.subtitle}}</div>
          </div>
          <div
            class="fb-button-block"
            v-for="(btn, btnIndex) in block.buttons"
            :key="`${uid}-fb-${blockIndex}-${btnIndex}`"
          >{{btn.title}}</div>
        </div>
      </div>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from '../MessageTemplate.vue';

export default {
  name: 'FbCarouselLayout',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.fb-carousel-layout {
  overflow-x: auto;
  min-width: 300px;
  max-width: 315px;
  .fb-carousel-wrapper {
    width: auto;
    display: flex;
  }
  .fb-generic-template {
    display: inline-block;
    border-radius: 18px;
    border: 1px solid #ddd;
    width: 300px;
    max-width: 300px;
    min-width: 300px;
    overflow: hidden;
    height: fit-content;
    &:not(:first-child) {
      margin-left: 5px;
    }
    .fb-thumb-block {
      border-bottom: 1px solid #ddd;
      width: 300px;
      max-height: 300px;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
    .fb-data-block {
      padding: 10px 0 10px 10px;
      .title {
        font-size: 0.9rem;
        font-weight: bold;
      }
      .subtitle {
        font-size: 0.9rem;
        color: rgba(0, 0, 0, 0.4);
      }
    }
    .fb-button-block {
      color: #0084ff;
      font-weight: 500;
      padding: 8px;
      text-align: center;
      border-top: 1px solid #ddd;
    }
  }
}
</style>
